/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import { navigate } from 'gatsby';
import { useMediaQuery, ThemeProvider, CssBaseline } from '@material-ui/core';

import theme from 'src/themes/meTheme';
import { isAccessTokenValid } from 'src/api/login';

import DesktopLayout from './desktopLayout';
import MobileLayout from './mobileLayout';

export default ({ children }) => {
  const matches = useMediaQuery('(min-width:600px)');
  const [isLoggedIn, setLogin] = useState(true);

  // useEffect(() => {
  //   if (isAccessTokenValid()) {
  //     setLogin(true);
  //   } else {
  //     navigate('/login/');
  //   }
  // }, []);

  return (
    isLoggedIn && (
      <ThemeProvider theme={theme}>
        <CssBaseline />
        {matches ? <DesktopLayout>{children}</DesktopLayout> : <MobileLayout>{children}</MobileLayout>}
      </ThemeProvider>
    )
  );
};
